export default "__VITE_ASSET__B1a_KOPS__"